import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../../utils/axios";
import { reduce, map, set, differenceWith, uniqBy } from "lodash";

export const getGeneralTrendsDataApi = createAsyncThunk(
  "generalGoogleTrendsData/getGeneralTrendsDataApi",
  async ({ date }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`googletrends/general_trends`, {
        params: date ? { date } : {},
      });
      return response.data;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

const initialGeneralGoogleTrendsState = {
  loading: false,
  data: {
    timestamp: null,
    total_articles: 0,
    articles: [],
  },
  completed: false,
  hasError: false,
  message: "",
};

const generalGoogleTrendsSlice = createSlice({
  name: "generalGoogleTrendsData",
  initialState: initialGeneralGoogleTrendsState,
  reducers: {
    clearData: () => {
      return initialGeneralGoogleTrendsState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getGeneralTrendsDataApi.pending, (state, { payload }) => {
        set(state, "loading", true);
        set(state, "hasError", false);
        set(state, "data", {
          timestamp: null,
          total_articles: 0,
          articles: [],
        });
      })
      .addCase(getGeneralTrendsDataApi.fulfilled, (state, { payload }) => {
        set(state, "loading", false);
        set(state, "hasError", false);
        set(state, "data", payload);
        set(state, "completed", true);
      })
      .addCase(getGeneralTrendsDataApi.rejected, (state, { payload }) => {
        set(state, "loading", false);
        set(state, "hasError", true);
        set(state, "completed", true);
        set(state, "message", payload);
      });
  },
});

const GeneralGoogleTrendsReducer = generalGoogleTrendsSlice.reducer;
export default GeneralGoogleTrendsReducer;

export const generalGoogleTrendsActions =
  generalGoogleTrendsSlice.actions;
